import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import styled from 'styled-components';

const LanguageButton = styled.button`
  background: none;
  border: none;
  color: ${props => props.active ? '#47ABDB' : 'white'};
  font-size: 1.2rem;
  cursor: pointer;
  font-weight: bold;
  padding: 0.5rem;
  
  &:hover {
    color: #47ABDB;
  }
`;

const LanguageWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const LanguagePicker = () => {
  const languageContext = useLanguage();
  const language = languageContext?.language || 'en';
  const setLanguage = languageContext?.setLanguage || (() => {});

  const handleLanguageChange = (newLanguage) => {
    if (typeof setLanguage === 'function') {
      setLanguage(newLanguage);
    }
  };

  return (
    <LanguageWrapper>
      <LanguageButton
        onClick={() => handleLanguageChange('de')}
        active={language === 'de'}
      >
        DE
      </LanguageButton>
      <LanguageButton
        onClick={() => handleLanguageChange('en')}
        active={language === 'en'}
      >
        EN
      </LanguageButton>
    </LanguageWrapper>
  );
};

export default LanguagePicker;